import {
  makeStyles,
  Typography,
  Grid,
  Switch,
  Box,
  CircularProgress,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  TextField,
  IconButton,
  Checkbox,
} from "@material-ui/core";
import { Delete, CheckCircle } from "@material-ui/icons";
import {
  fetchCollaboratorType,
  addPartnerType,
  updatePartnerType,
  deletePartnerType,
  fetchNetworkType,
  getNetworkRoles,
} from "../../../../containers/actions/netwrokActions";
import { FETCH_COLLABORATOR_TYPE_LOADING, FETCH_NETWORK_TYPES_LOADING, GET_NETWORK_ROLES_LOADING } from "../../../../containers/actions/types";
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from "@material-ui/icons/Save";
import ClearIcon from "@material-ui/icons/Clear";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import RoleManagement from "./RoleManagement";
import NetworkDetails from "./NetworkDetails";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#1890ff",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#1890ff",
    },
  },
  inline: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  table: {
    maxWidth: 650,
    border: "1px solid #e0e0e0",
    marginTop: 10,
  },
  smallCell: {
    padding: "4px 8px",
    fontSize: "0.875rem",
  },
  urlField: {
    marginTop: 20,
    maxWidth: 400,
  },
   saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
       width: "12rem",
      fontSize: "1rem",
      fontWeight: 550,
        cursor: "pointer",
                // paddingLeft:"3rem",
                // paddingRight:"3rem",
       paddingTop: "0.35rem",
                paddingBottom: "0.35rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton:{
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
       width: "12rem",
      fontSize: "1rem",
      fontWeight: 550,
        cursor: "pointer",
                // paddingLeft:"3rem",
                // paddingRight:"3rem",
       paddingTop: "0.35rem",
                paddingBottom: "0.35rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
  actions: {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between",
    maxWidth: 650,
  },
}));

// const initialPartnerTypes = [
//     { partnerType: "CDMO", partnerTypeID: "01", isSelected: false },
//     { partnerType: "COO", partnerTypeID: "02", isSelected: false },
//     { partnerType: "CRD", partnerTypeID: "03", isSelected: false },
//     { partnerType: "CRDMO", partnerTypeID: "04", isSelected: false },
//     { partnerType: "DSMO", partnerTypeID: "05", isSelected: false },
//     { partnerType: "Logistics", partnerTypeID: "06", isSelected: false },
//   ];

const PartnerType = ({ selectedEcosystemTypeID, activeTab, setActiveTab,addSponsorList,rowData,updateNetworkData,setUpdateNetworkData,rowNetwork, existingSponsorFlow, networkURL}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  // const [activeTab, setActiveTab] = useState(1);
  // const [partnerTypes, setPartnerTypes] = useState(initialPartnerTypes);
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [deselectedIndices, setDeselectedIndices] = useState([]);
  const [toggleError, setToggleError] = useState(false);

  

  // const [networkURL, setNetworkURL] = useState("");

  const [partnerTypes, setPartnerTypes] = useState([]);
  const initialPartnerTypes = useSelector(
    (state) => state?.network?.partnerDetails || []
  );

  const initialNetworkTypes = useSelector(
    (state) => state?.network?.networkDetails || []
  );


    const updateNetworkDetails = useSelector(
      (state) => state?.network?.updateNetworkDetails || []
    );

    let fetchViewSponsorData = useSelector(
      (state) => state?.network?.selectedSponsorDetails?.SponsorDetails || []
    );

  
    // const [updateNetworkData,setUpdateNetworkData] =useState({});

    useEffect (()=>{
if(updateNetworkDetails?.ecosystemUrl)
  {(setUpdateNetworkData(updateNetworkDetails))}
    },[updateNetworkDetails?.ecosystemUrl])


  const initialPartnerTypesLoading = useSelector(
    (state) => state?.network?.partnerDetailsTypeLoading || []
  );

  useEffect(() => {
    dispatch({
      type: FETCH_COLLABORATOR_TYPE_LOADING,
      payload: true,
    });

    if (existingSponsorFlow && addSponsorList?.data?.ecosystemId) {

      dispatch({
        type: FETCH_COLLABORATOR_TYPE_LOADING,
        payload: true,
      });
      
      dispatch(fetchCollaboratorType(addSponsorList?.data?.ecosystemId));
      return 
    }

    if (rowData?.status === "Pending" && rowData?.ecosystemId &&
      (Array.isArray(addSponsorList) && addSponsorList.length === 0)
    ) {
      dispatch(fetchCollaboratorType(rowData.ecosystemId));
    } else if (addSponsorList?.data?.ecosystemId) {
      dispatch(fetchCollaboratorType(addSponsorList.data.ecosystemId));
    }
  }, [addSponsorList?.data?.ecosystemId, rowData?.ecosystemId, rowData?.status]);

  useEffect(() => {
    if (initialPartnerTypes && initialPartnerTypes?.data?.length > 0) {
      setPartnerTypes(initialPartnerTypes?.data);
    }
  }, [initialPartnerTypes]);

  const handleTabChange = (_, newValue) => setActiveTab(newValue);

  // const handleSaveNext = () => {
  //  if (activeTab === 1) {
  //           // const selectedItem = partnerTypes[selectedIndices];
  //           const selectedIds = selectedIndices
  //           .map((i) => partnerTypes[i]?.collaborator_type_id)
  //           .filter(Boolean) // filters out undefined/null
  //           .join(",");
  //           // if (selectedItem) {
  //           dispatch(updatePartnerType({
  //             partnerTypeIds: selectedIds,
  //             ecoSystemTypeID:initialNetworkTypes?.selectedNetworkTypeId,
  //              ecosystemID : 1,

  //           }));
  //         // }
  //   }

  //   if (activeTab < 2) {
  //     setActiveTab((prev) => prev + 1);
  //   }
  // };

  // const handleSaveNext = () => {
  //   if (activeTab === 1) {
  //     // Step 1: collect all indices that are ON (either activated or toggled)
  //     const selectedIds = partnerTypes
  //       .map((item, index) => {
  //         const isCurrentlyOn = item.activated || selectedIndices.includes(index);
  //         const isTurnedOff = item.activated && !selectedIndices.includes(index); // turned off
  //         return isCurrentlyOn && !isTurnedOff
  //           ? item.collaborator_type_id
  //           : null;
  //       })
  //       .filter(Boolean)
  //       .join(",");

  //     dispatch(updatePartnerType({
  //       partnerTypeIds: selectedIds,
  //       ecoSystemTypeID: initialNetworkTypes?.selectedNetworkTypeId,
  //       ecosystemID: 1,
  //     }));
  //   }

  //   if (activeTab < 2) {
  //     setActiveTab((prev) => prev + 1);
  //   }
  // };


  const handleSaveNext = async () => {
    if (activeTab === 1) {
      if (!isAtLeastOneToggled()) {
        setToggleError(true);
        return;
      }
      setToggleError(false);

      const selectedIds = partnerTypes
        .map((item, index) => {
          const isActive =
            (item.activated && !deselectedIndices.includes(index)) ||
            selectedIndices.includes(index);
          return isActive ? item.collaborator_type_id : null;
        })
        .filter(Boolean)
        .join(",");

      if ((selectedEcosystemTypeID || initialNetworkTypes?.selectedNetworkTypeId) && (addSponsorList?.data?.ecosystemId || rowData?.ecosystemId)) {
        await dispatch(
          updatePartnerType({
            partnerTypeIds: selectedIds,
            ecoSystemTypeID: selectedEcosystemTypeID || initialNetworkTypes?.selectedNetworkTypeId,
            ecosystemID: addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
          })
        );
      }

      dispatch({
        type: FETCH_COLLABORATOR_TYPE_LOADING,
        payload: true,
      });

      setTimeout(() => {
        if (
          rowData?.status === "Pending" &&
          rowData?.ecosystemId &&
          Array.isArray(addSponsorList) &&
          addSponsorList.length === 0
        ) {
          dispatch(fetchCollaboratorType(rowData.ecosystemId));
        } else if (addSponsorList?.data?.ecosystemId) {
          dispatch(fetchCollaboratorType(addSponsorList.data.ecosystemId));
        }
      }, 3000);
    }

    if (activeTab < 2) {
      setActiveTab((prev) => prev + 1);
    }
  };

  const handleAddRow = () => {
    const newId = (partnerTypes.length + 1).toString().padStart(2, "0");
    setPartnerTypes([
      ...partnerTypes,
      {
        collaborator_type_name: "",
        collaborator_type_id: newId,
        edit: true,
        isNew: true,
        is_default: 0,
      },
    ]);
  };

  const handleDeleteRow = async (item, index) => {
      if (item.isNew) {
    const updated = [...partnerTypes];
    updated.splice(index, 1);
    setPartnerTypes(updated);
    return;
  }

    try {
      await dispatch(
        deletePartnerType({
          collaboratorTypeId: item?.collaborator_type_id,
          ecosystemTypeId: initialNetworkTypes?.selectedNetworkTypeId, // ecosystem_type_id
          isDeleted: "1",
        })
      );
      dispatch({
        type: FETCH_COLLABORATOR_TYPE_LOADING,
        payload: true,
      });

      setTimeout(() => {
          if (rowData?.status === "Pending" && rowData?.ecosystemId &&
            (Array.isArray(addSponsorList) && addSponsorList.length === 0)
          ) {
            dispatch(fetchCollaboratorType(rowData.ecosystemId));
          } else if (addSponsorList?.data?.ecosystemId) {
            dispatch(fetchCollaboratorType(addSponsorList.data.ecosystemId));
          }
      }, 3000);
    } catch (error) {
      console.error("Failed to add partner details:", error);
      // Optionally show error UI
    }
  };

  const handleInputChange = (index, value) => {
    const updated = [...partnerTypes];
    updated[index].collaborator_type_name = value;
    setPartnerTypes(updated);
  };

  // const handleSave = (index) => {
  //   const itemToSave = partnerTypes[index];

  //   dispatch(addPartnerType({
  //     newPartnerType: itemToSave.collaborator_type_name,
  //     newPartnerTypeID: itemToSave.collaborator_type_id,
  //      ecosystemTypeId:"1",
  //      isDefault:false,
  //   }));

  //     dispatch({
  //           type: FETCH_COLLABORATOR_TYPE_LOADING,
  //           payload: true,
  //         });

  //         dispatch(
  //           fetchCollaboratorType()
  //         );

  //   // Optionally: update 'edit' state
  //   // const updatedPartnerTypes = [...partnerTypes];
  //   // updatedPartnerTypes[index].edit = false;
  //   // setPartnerTypes(updatedPartnerTypes);
  // };


  const isAtLeastOneToggled = () => {
    return partnerTypes.some(
      (item, index) =>
        (item.activated && !deselectedIndices.includes(index)) ||
        selectedIndices.includes(index)
    );
  };

  const handleSave = async (index) => {
    if (!isAtLeastOneToggled()) {
      setToggleError(true);
      return;
    }
    setToggleError(false);
    const itemToSave = partnerTypes[index]; // or partnerTypes[index], depending on context

    try {
      // Wait for addPartnerType to complete
     await dispatch(
        addPartnerType({
          newPartnerType: itemToSave.collaborator_type_name,
          newPartnerTypeID: itemToSave.collaborator_type_id,
          ecosystemTypeId: initialNetworkTypes?.selectedNetworkTypeId,
          isDefault: false,
        })
      );

      // Then dispatch the next two actions
       dispatch({
        type: FETCH_COLLABORATOR_TYPE_LOADING,
        payload: true,
      });

          if (rowData?.status === "Pending" && rowData?.ecosystemId &&
            (Array.isArray(addSponsorList) && addSponsorList.length === 0)
          ) {
              setTimeout(() => {
            dispatch(fetchCollaboratorType(rowData.ecosystemId));
            },2000);
          } else if (addSponsorList?.data?.ecosystemId) {
            setTimeout(() => {
            dispatch(fetchCollaboratorType(addSponsorList.data.ecosystemId));
              },2000);
          }

      // // Optional: exit edit mode or update local state
      // const updated = [...partnerTypes]; // assuming your state variable
      // updated[index].edit = false;
      // setPartnerTypes(updated);
    } catch (error) {
      console.error("Failed to add partner details:", error);
      // Optionally show error UI
    }
  };

  const handleClear = (index) => {
    const updated = [...partnerTypes];
    updated[index].collaborator_type_name = ""; // Or revert to original if needed
    // updated[index].edit = false;
    setPartnerTypes(updated);
  };

  // const handleCheckboxChange = (index) => {
  //   setSelectedIndices((prev) =>
  //     prev.includes(index)
  //       ? prev.filter((i) => i !== index)
  //       : [...prev, index]
  //   );
  // };

  const handleCheckboxChange = (index) => {
    const isSelected = selectedIndices.includes(index);
    const isDeselected = deselectedIndices.includes(index);

    if (partnerTypes[index].activated) {
      // User is toggling an already activated item
      if (isDeselected) {
        // Re-enable it
        setDeselectedIndices((prev) => prev.filter((i) => i !== index));
      } else {
        // Disable it
        setDeselectedIndices((prev) => [...prev, index]);
      }
    } else {
      // Handle non-activated items as before
      setSelectedIndices((prev) =>
        isSelected ? prev.filter((i) => i !== index) : [...prev, index]
      );
    }
    // After toggling, clear error if at least one is active
    if (isAtLeastOneToggled()) {
      setToggleError(false);
    }
  };

  // useEffect(() => {
  //   dispatch({
  //     type: FETCH_NETWORK_TYPES_LOADING,
  //     payload: true,
  //   }); 
  
  //   console.log("1234567890")
  
  //     dispatch(fetchNetworkType(rowData.ecosystemId));
   
  // }, [addSponsorList?.data?.ecosystemId, rowData?.ecosystemId, rowData?.status]);


  

  return (
    <div>
      <Table style={{ marginTop: "2rem" }} className={classes.table}>
        <TableHead style={{ backgroundColor: "#F9F9FC" }}>
          <TableRow>
            <TableCell className={classes.smallCell}>Selection</TableCell>
            <TableCell className={classes.smallCell}>Partner Types</TableCell>
            <TableCell align="right" className={classes.smallCell}>
              Partner Type ID
            </TableCell>
            <TableCell
              style={{ paddingLeft: "2rem" }}
              className={classes.smallCell}
            >
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        {initialPartnerTypesLoading === true ? (
          <TableRow style={{ height: 150 }}>
            <TableCell colSpan={12}>
              <div style={{ textAlign: "center" }}>
                <CircularProgress color="primary" thickness={7} />
              </div>
            </TableCell>
          </TableRow>
        ) : partnerTypes?.length > 0 ? (
          <TableBody>
            {partnerTypes.map((item, index) => (
              <TableRow key={index}>
                <TableCell className={classes.smallCell}>
                  {/* <Switch
                                              classes={{ root: classes.root }}
                                              checked={selectedIndices.includes(index) || item.activated === true}
                                              onChange={() => handleCheckboxChange(index)}
                                              disabled={item.isNew} 
                                            />                 */}

                  <Switch
                    classes={{ root: classes.root }}
                    checked={
                      (item.activated && !deselectedIndices.includes(index)) ||
                      selectedIndices.includes(index)
                    }
                    onChange={() => handleCheckboxChange(index)}
                    disabled={item.isNew}
                  />
                </TableCell>
                <TableCell className={classes.smallCell}>
                  {item.edit ? (
                    <>
                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: "3px",
                        }}
                      >
                        <TextField
                          variant="outlined"
                          size="small"
                          value={item.collaborator_type_name}
                          onChange={(e) =>
                            handleInputChange(index, e.target.value)
                          }
                          onInput={(e) => {
  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
}}
                        />
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "3px",
                          }}
                        >
                          <span title="clear">
                            <ClearIcon
                              // onClick={() => setEdit(false)}
                              onClick={() => handleClear(index)}
                              style={{ cursor: "pointer", fontSize: "medium" }}
                            />
                          </span>
                          <span title="save">
                            {/* <SaveIcon
                              onClick={() => handleSave(index)} // pass index of the row
                              // onClick={handleSave}
                              style={{ cursor: "pointer", fontSize: "medium" }}
                            /> */}

                            <SaveIcon
                              onClick={() => {
                                const trimmedValue = item.collaborator_type_name.trim();
                                const isDuplicate = partnerTypes.some(
                                  (nt, i) =>
                                    i !== index && nt.collaborator_type_name.trim().toLowerCase() === trimmedValue.toLowerCase()
                                );
                            
                                if (trimmedValue !== "" && !isDuplicate) {
                                  handleSave(index);
                                }
                              }}
                              style={{
                                cursor:
                                  item.collaborator_type_name.trim() === "" ||
                                  partnerTypes.some(
                                    (nt, i) =>
                                      i !== index &&
                                      nt.collaborator_type_name.trim().toLowerCase() === item.collaborator_type_name.trim().toLowerCase()
                                  )
                                    ? "not-allowed"
                                    : "pointer",
                                fontSize: "medium",
                                color:
                                  item.collaborator_type_name.trim() === "" ||
                                  partnerTypes.some(
                                    (nt, i) =>
                                      i !== index &&
                                      nt.collaborator_type_name.trim().toLowerCase() === item.collaborator_type_name.trim().toLowerCase()
                                  )
                                    ? "gray"
                                    : "inherit",
                              }}
                            />
                          </span>
                        </Box>
                      </Box>
                    </>
                  ) : (
                    <Typography variant="body2">
                      {item.collaborator_type_name}
                    </Typography>
                  )}
                </TableCell>
                <TableCell align="right" className={classes.smallCell}>
                  {item?.collaborator_type_id || "NA"}
                </TableCell>
                <TableCell
                  style={{ paddingLeft: "2rem" }}
                  className={classes.smallCell}
                >
                  {item.is_default === 0 && (
                    <IconButton
                      disableRipple
                      disableFocusRipple
                      disableTouchRipple
                      sx={{
                        backgroundColor: "transparent",
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                        "&:focus": {
                          backgroundColor: "transparent",
                        },
                      }}
                      onClick={() => handleDeleteRow(item, index)}
                    >
                      <Delete style={{ color: "red" }} />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        ) : initialPartnerTypes?.status === false ? (
          <TableRow
            style={{
              border: "2px solid rgb(255,0,0)",
              backgroundColor: "rgb(255,240,240)",
              Opacity: 1,
              textAlign: "center",
              padding: "0.8rem",
              fontSize: "0.875rem",
            }}
          >
            <TableCell colSpan={10} align="center">
              {"Something went wrong. Please contact Schrocken Support."}
            </TableCell>
          </TableRow>
        ) : (
          <TableRow>
            <TableCell colSpan={9} align="center">
              No records found
            </TableCell>
          </TableRow>
        )}
      </Table>

      {toggleError && (
        <p style={{ color: 'red', marginTop: 8 }}>
          At least one Partner Type must be selected.
        </p>
      )}

      <Button
        variant="outlined"
        onClick={handleAddRow}
        style={{
          marginTop: 10,
          border: "1px solid black",
          borderRadius: "4rem",
          textTransform: "none",
          fontSize: "1rem",
          fontWeight: "550",
        }}
      >
        <AddCircleOutlineIcon />
        {"  "} Add New Partner Type
      </Button>

      {/* <div style={{ marginTop: 30 }} className={classes.actions}>
        <Button variant="contained" disabled={activeTab === 0} onClick={() => setActiveTab((prev) => prev - 1)}>
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveNext}
          // disabled={ && activeTab === 0}
        >
          Save & Next
        </Button>
      </div> */}

      <div style={{ marginTop: 30 }} className={classes.actions}>
        {/* <Grid
          variant="contained"
          disabled={activeTab === 0}
          onClick={() => setActiveTab((prev) => prev - 1)}
          style={{
            backgroundColor: "#707070",
            color: "white",
            width: "10rem",
            fontSize: "1rem",
            fontWeight: 550,
            // paddingLeft:"3rem",
            // paddingRight:"3rem",
            paddingTop: "0.5rem",
            paddingBottom: "0.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "5rem",
            cursor: "pointer",
          }}
        >
          <ChevronLeftIcon />
          Back
        </Grid>
        <Grid
          variant="contained"
          onClick={handleSaveNext}
          style={{
            backgroundColor: "#EC6535",
            color: "white",
            width: "10rem",
            fontSize: "1rem",
            fontWeight: 550,
            paddingTop: "0.5rem",
            paddingBottom: "0.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "5rem",
            cursor: "pointer",
          }}
        >
          Save & Next
          <ChevronRightIcon />
        </Grid> */}

                          <Grid
                  className={classes.backButton}
                     disabled={activeTab === 0}
          onClick={() => setActiveTab((prev) => prev - 1)}
                     >
                   <ChevronLeftIcon />
                     Back
                 </Grid>
                    <Grid
                  className={classes.saveButton}
                   onClick={handleSaveNext}
                     >
                      Save & Next
                    <ChevronRightIcon />
                    </Grid>
      </div>
      {/* {activeTab === 1 && <PartnerType initialNetworkTypes={initialNetworkTypes}/>} */}
      {/* {activeTab === 2 && <RoleManagement/>}
      {activeTab === 0 && <NetworkDetails/>} */}
    </div>
  );
};

export default PartnerType;
